export function SubjectCommands() {
  return null;
  // // Saved for later
  // return (
  //   <>
  //     {!page && (
  //       <CommandGroup heading="Subject">
  //         <CommandItem disabled>
  //           <PencilIcon />
  //           Edit subject
  //         </CommandItem>
  //       </CommandGroup>
  //     )}
  //   </>
  // );
}
